import { useState } from "react";
import { Form, Flex } from "antd";

import { WhiteBoxBlock } from "ui";
import { changePassword } from "services";
import { useStores } from "stores";
import { ChangePasswordForm } from "components";

import styles from "./login.module.css";
import { BgLogo } from "./BgLogo";

type FieldType = {
  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
};

export const ChangePasswordPage = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { user } = useStores();

  const onFinish = () => {
    const values: FieldType = form.getFieldsValue();

    setLoading(true);
    setError("");

    changePassword(values)
      .then(() => {
        user.logout();
      })
      .catch((e) => setError(e.title || "Не удалось сменить пароль"))
      .finally(() => setLoading(false));
  };

  return (
    <Flex align="center" justify="center" className={styles.loginBox}>
      <BgLogo />
      <WhiteBoxBlock>
        <ChangePasswordForm form={form} disabled={loading} onFinish={onFinish} />
        {error && (
          <Flex justify="center" className={styles.loginError}>
            {error}
          </Flex>
        )}
      </WhiteBoxBlock>
    </Flex>
  );
};
